import React, { useContext, useEffect, useState } from 'react';
import './HotDealsPage.css';
import TopBack from '../../components/TopBack/TopBack.jsx';
import HotDealsIcon from '../../assets/HotDealsIcon.jsx';
import HotDealVouchers from '../../components/HotDealVouchers/HotDealVouchers.jsx';
import { useParams, useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import Voucher from '../../components/Voucher/Voucher.jsx';
import { CampaignContext } from '../../services/context/CampaignContext.js';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';
import { hotDealsPage } from '../../services/Constants/config.js';

/**
 * @returns {JSX.Element} HotDealsPage
 */
export default function HotDealsPage() {
  const { id: idParam } = useParams();
  const navigateTo = useNavigate();
  const [allowedCampaignIDs, setAllowedCampaignIDs] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const campaignIDs = useContext(CampaignContext);
  const campaignIdsFromURL = idParam ? idParam.split(',') : [];
  const subscriptionStatus = useNormalizedSubscriptionStatus();

  useEffect(() => {
    if (Array.isArray(campaignIDs)) {
      setAllowedCampaignIDs(campaignIdsFromURL.filter(c => campaignIDs.includes(c)));
      setLoading(false);
    }
  }, [campaignIDs]);

  useEffect(() => {
    window.utag?.view({
      ...defaultAnalyticsVariables,
      event_name: [events.pageView],
      page_name: `${pagePrefix}: hot deals`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  }, []);

  const skeletonVouchers = Array.from({ length: 2 }, (_, key) => <Voucher key={ key } />);

  const NoDeals = () => {
    const emptySkeletonStyle = {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    };

    if (!isLoading) {
      navigateTo(ROUTES.INVALID_HOTDEAL_PAGE);
    }

    return (
      <div
        className='empty skeleton-loader'
        style={ emptySkeletonStyle }
      >
        { skeletonVouchers }
      </div>
    );
  };

  return (
    <div className='hot-deals-container'>
      <TopBack />
      <div className='hotDeal-header-container'>
        <HotDealsIcon />
        <span className='hotDeal-header'>Hot deals just for you</span>
      </div>
      <HotDealVouchers
        campaignIds={ allowedCampaignIDs }
        onEmpty={ <NoDeals /> }
        pageLabel={ hotDealsPage }
      />
    </div>
  );
}
